export const regexPatterns = {
  // Allows only Persian letters and spaces.
  persianText: /^[\u0600-\u06ED\u06FA-\u06FC\u06FE-\u06FF\s]+$/,

  // Disallows English alphabet.
  noEnglishAlphabet: /^[^A-Za-z]*$/,

  // Allows only digits: English (0-9), Persian (۰-۹), and Arabic (٠-٩).
  digitsOnly: /^[0-9\u06F0-\u06F9\u0660-\u0669]+$/,

  // Validates email addresses, allowing English and Persian/Arabic digits in the local part.
  email:
    /^[a-zA-Z0-9\u06F0-\u06F9\u0660-\u0669._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

  // Allows only English letters (a-z, A-Z) and digits (0-9). Useful for usernames, etc.
  alphanumeric: /^[a-zA-Z0-9]+$/,

  // Disallows most special characters. Useful for name fields where symbols shouldn't appear.
  noSpecialChars: /^[^@#$%^&*()_+=[\]{}|\\:;"'<>?,./`~]+$/,

  // Allows only Persian letters, digits (English, Persian, Arabic), ZWNJ, and spaces.
  brandName:
    /^[\u0621-\u063A\u0641-\u064A\u067E\u0686\u0698\u06A9\u06AF\u06CC\u200Cءٔ‌0-9\u06F0-\u06F9\u0660-\u0669 ]+$/,

  // Detects a letter stuck to a digit (e.g. "خیابان12" or "12متری").
  letterAdjacentToDigit: /(?:\p{L}\p{N}|\p{N}\p{L})/u
}
